<style lang="less">
body {
  margin: 0;
  //强制padding为0，el-dialog弹出时，会给body增加padding-right:15px
  padding: 0 !important;
}

.el-empty {
  padding: 0 !important;
}

.sms-loading {
  border-radius: 10px;
}
</style>
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>



// WEBPACK FOOTER //
// src/App.vue